import FizConfig from "./FizConfig.js";
import * as actionsUnlogged from "./actions_unlogged.js";
import ApiServer from "./ApiServer.js";
import * as FwDatas from "./FwDatas.ts";
import * as websocket from "./util/websocket.js";
import deviceId from "./lib/deviceId.js";
import * as firebaseMessaging from "./firebaseMessaging.js";
import * as notificationBullet from "./widget/notification-bullet.js";
import {checkEmailverified} from "./features/email_verify.js";

import "./global_connected.js";
import { OS } from "./lib/os.js";
import * as modal from "./util/modal.ts";


var 
  resetThen = actionsUnlogged.resetThen,
  ensureSafariCookieThen = actionsUnlogged.ensureSafariCookieThen,
  controlPush = actionsUnlogged.controlPush,
  loadLanguagePropertiesThen = actionsUnlogged.loadLanguagePropertiesThen;

/*
 * Function: setFamiliesThen(next) Set the family LIST in a chain of
 * actions
 * 
 * Parameter: next - function(callback), the next action to call, with the
 * callback function as parameter
 * 
 * Returns: function(callback,data), the action that sets the family LIST
 * and starts the next action, forwarding the callback and current data
 * 
 * Note: User must be authenticated.
 * 
 */


function setFamiliesThen(next) {
  return async function(callback, data) {
    
    ApiServer.setGroupOptions({progressbar:"standard"});
    
    var promises = []
    promises.push(ApiServer.accgetallfamily(function(extentedFamily) {
      FwDatas.setFamily(extentedFamily);
    }));
    //this one is kept for ghost profile
    promises.push(ApiServer.prfgetProfiles(function(profiles) {
      FwDatas.setProfiles(profiles);
    }));
    if (!FwDatas.getFamilies() || FwDatas.getFamilies().length === 0) {
      promises.push(ApiServer.famlistfamily(function(famList) {
        FwDatas.setFamilies(famList);
      }));
      promises.push(ApiServer.settingsgetperfamily(function(settingsPerFamily){
        FwDatas.setSettingsPerFamily(settingsPerFamily);
      }))
      
    }
    promises.push(ApiServer.famshowincominginvite(function(famInvite) {
      FwDatas.setInvitations(famInvite);
    }));
    if(!websocket.isActive || notificationBullet.get("imunreadthread")===undefined){
      promises.push(ApiServer.customimthreadlist());
    }
    if(FwDatas.getState()===undefined){
      promises.push(ApiServer.accgetstate(deviceId, "WebFirebase", FizConfig.jsVersion||"", function(accountState) {
        FwDatas.setState(accountState);
      }));
    }
    try{
      await Promise.all(promises);
      next(callback, data);
      firebaseMessaging.default.register();
      checkEmailverified()
    }catch(e){
      console.log(e)
      //next(callback, data);
    }
  };
}


/*
 * Function: endOfChain(callback,data) Trigger the callback at the end of
 * a chain of actions
 * 
 * Parameters: callback - function(data), the callback function to trigger
 * at the end of the chain, providing current data as argument data -
 * object, current data
 */
function endOfChain(callback, data) {
  callback(data);
}

/*
  Function: getStartSequence(isLogged): function
  Get the start sequence to initialize a page

  Parameter:
    isLogged - boolean, whether the user is logged

  Returns:
    function, a function to trigger the start sequence to intialize a page;
    a shorter sequence is returned when user is not logged, omitting requests
    that require user authentication.
 */
export function getStartSequence(isLogged, end) {
  end = end || endOfChain;
  if (isLogged) {
    return loadLanguagePropertiesThen(ensureSafariCookieThen(controlPush(setFamiliesThen(loadLanguagePropertiesThen(end)))));
  } else {
    return ensureSafariCookieThen(controlPush(resetThen(loadLanguagePropertiesThen(end))));
  }
}
   
